import { hasAuthorization, RoleRules } from "../composables/team";

import { log } from "~/composables/log";

export default defineNuxtRouteMiddleware(async () => {
	await waitAuth();
	await waitForPB();

	// eslint-disable-next-line no-magic-numbers
	await new Promise(resolve => setTimeout(resolve, 250));

	if (!hasAuthorization(RoleRules.Partner)) {
		log("❌ Has no role authorization to access this page");
		return navigateTo("/");
	}

	log("✅ Has role authorization");
});
